import { useEffect } from 'react';

// PROJECT-REALCHANGE.md §7.1 — web component de Vturb.
// El script del player se inyecta una sola vez.
const PLAYER_ID = 'vid-6a2b62766c947a37b9654655';
const PLAYER_SRC =
  'https://scripts.converteai.net/59d240e9-3e2b-416d-a63e-394318791e63/players/6a2b62766c947a37b9654655/v4/player.js';

let scriptInjected = false;

export function VslPlayer() {
  useEffect(() => {
    if (scriptInjected || document.querySelector(`script[src="${PLAYER_SRC}"]`)) return;
    const s = document.createElement('script');
    s.src = PLAYER_SRC;
    s.async = true;
    document.head.appendChild(s);
    scriptInjected = true;
  }, []);

  return (
    <vturb-smartplayer
      id={PLAYER_ID}
      style={{ display: 'block', margin: '0 auto', width: '100%' }}
    />
  );
}
